export default __webpack_public_path__ + "static/equitas-1daa71f6f3b2a7ed8dd560044a72ded8.png";